import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MapaFacilComponent } from './mapa-facil/mapa-facil.component';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [MapaFacilComponent],
  imports: [CommonModule, GoogleMapsModule],
  exports: [MapaFacilComponent],
})
export class MapaFacilModule {}
